module.exports = {
  email: "lowbak1998@hotmail.com",
  company: "https://www.dasher.com.my/",
  intern: "https://www.datumcorp.com/",
  navLinks: [
    {
      name: "About",
      url: "#about",
    },
    {
      name: "Background",
      url: "#background",
    },
    {
      name: "Projects",
      url: "#projects",
    },
    {
      name: "Contact",
      url: "#contact",
    },
  ],
  socials: [
    {
      name: "github",
      url: "https://github.com/lowzijian",
    },
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/low-zi-jian-b19535191/",
    },
    {
      name: "spotify",
      url: "https://open.spotify.com/user/22flmlrujoiwjduewifdlgw5q",
    },
    {
      name: "behance",
      url: "https://www.behance.net/jakelow2/appreciated",
    },
    {
      name: "dribbble",
      url: "https://dribbble.com/jakelow",
    },
  ],
  project_done_count: 25,
  coffee_drank_count: 365,
};
